<template>
  <el-dialog
    v-if="visible"
    visible
    :title="title"
    show-close
    top="5vh"
    width="90%"
    :close-on-click-modal="false"
    :before-close="() => close()"
    v-el-dialog-drag
    :modal-append-to-body="false"
    :modal="false"
  >
    <Main
      ref="main"
      :multiple="multiple"
      :evgSpuCode="evgSpuCode"
      @change="(e) => (checkedRow = e)"
    />
    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-badge :value="checkedCount" class="ml-2" v-if="multiple">
        <el-button
          type="primary"
          size="small"
          @click="confirm()"
          :disabled="!checkedCount"
        >
          {{ $l('INDEX.btn_confirm') || '确认' }}
        </el-button>
      </el-badge>
      <el-button
        v-else
        type="primary"
        size="small"
        @click="confirm()"
        :disabled="!checkedCount"
      >
        {{ $l('INDEX.btn_confirm') || '确认' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    title: { type: String, default: '' },
    visible: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    confirmOnClose: { type: Boolean, default: true },
    evgSpuCode: { type: String, default: '' },
  },
  data() {
    return { checkedRow: null }
  },
  computed: {
    checkedCount() {
      return this.multiple
        ? this.checkedRow?.length || 0
        : this.checkedRow
        ? 1
        : 0
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
      this.checkedRow = null
    },
    confirm() {
      if (!this.checkedCount) return
      this.$emit('confirm', this.checkedRow)
      if (this.confirmOnClose) this.close()
    },
  },
}
</script>
